<form class="invite-form" (submit)="onSubmit($event)">
  <div class="invite-content">
    <p class="invite-description-text">Der Mitarbeiter erhält eine Einladung per E-Mail.</p>
    <div class="invite-contact-details">
      <ui-form-text [data]="customerNumberData" [formControl]="customerNumberControl"></ui-form-text>
      <ui-form-text [data]="emailData" [formControl]="emailControl"></ui-form-text>
    </div>
    <div class="invite-role-details">
      <ui-form-selection-list
        appearance="flat"
        [data]="rolesData()"
        [formControl]="rolesControl"
      ></ui-form-selection-list>
    </div>
  </div>
  <div class="invite-footer">
    <ui-button type="submit">Einladung senden</ui-button>
    <ui-button buttonStyle="text" type="button" (clicked)="onCancel()">Abbrechen</ui-button>
  </div>
</form>
